module.exports = __webpack_public_path__ + "af.4bde77199333f65a1aad.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/af.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/af.svg
// module chunks = styles